import { AxiosResponse } from "axios";
import React, { createContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useProSidebar } from "react-pro-sidebar";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../common/utils/api";
import { axiosGet } from "../../common/utils/helper";
import Breadcrumb from "../header/breadcrumb";
import Header from "../header/header";
import SidebarComponent from "../sidebar/sidebar";
import "./layout.scss";
import { TourProvider } from "../../common/utils/TourContext";
import Loader from "../Loader/loader";

type LayoutProps = {
  children: React.ReactNode;
  paths?: any;
};

export const UserContext: any = createContext("");

const Layout = (props: LayoutProps) => {
  let response: any;
  const publicRoutes = ["/fail", "/success", "signup", "/pricing"];

  const location = useLocation();
  const { collapsed, broken } = useProSidebar();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<string>("");
  const navigate = useNavigate();
  const [isRenewalPage, setRenewalPage] = useState(false);
  async function getUserDetails(reqUrl: string) {
    response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    setUser(response.data.data);
    localStorage.setItem("isAppTourCompleted", response.data.data.IsAppTourCompleted);
    if (response?.data?.data?.access[0] === "Renewal Page") {
      setRenewalPage(true);
      navigate("/renewalPage");
    }
    setLoading(false);
  }
  let token = localStorage.getItem("accessToken");

  useEffect(() => {
    token = localStorage.getItem("accessToken");
    if (
      !token &&
      !location.search &&
      !publicRoutes.some((r) => location.pathname?.includes(r))
    ) {
      navigate("/login");
    }

    if (location.pathname !== "/login") {
      if (
        (!location.search && location.pathname === "/fail") ||
        ["/pricing", "/success"].includes(location.pathname) ||
        location.pathname?.includes("/signup")
      ) {
        setLoading(false);
      }
      if (
        location.pathname !== "/candidateProfile" &&
        location.pathname !== "/candidateFeedback" &&
        location.pathname !== "/fail" &&
        location.pathname !== "/chat-bot" &&
        location.pathname !== "/success" &&
        location.pathname !== "/set-password" &&
        !location.pathname?.includes("/signup") &&
        !["/pricing"].includes(location.pathname)
      ) {
        setLoading(true);
        getUserDetails(getUser);
      }
    }
  }, [token]);
  useEffect(() => {
    try {
      if (location.search) {
        setLoading(true);
        const token = new URLSearchParams(location.search)
          .get("token")
          ?.replace(/ /g, "+");
        if (token && !location.pathname.includes("set-password")) {
          localStorage.setItem("accessToken", token);
          setLoading(false);
        } else {
          setLoading(false);
          console.log("Token is null or empty");
        }
      }
    } catch (error) {
      console.error("Error accessing localStorage:", error);
    }
  }, [location.search]);
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <UserContext.Provider value={{ user, setUser }}>
          <TourProvider>
          {["/login", "/pricing"].includes(location.pathname) ||
          location.pathname.includes("/signup") ? (
            <div className="login-page">{props.children}</div>
          ) : [
              "/candidateProfile",
              "/candidateFeedback",
              "/fail",
              "/success",
              "/set-password",
              "/chat-bot",
              // "/renewalPage"
            ].includes(location.pathname) ? (
            <div className="d-flex h-100">
              <Container fluid>{props.children}</Container>
            </div>
          ) : (
            token && (
              <div className="d-flex h-100">
                {!isRenewalPage && <SidebarComponent />}
                <main
                  className={`${
                    isRenewalPage ? "main-content-renewal" : "main-content"
                  } ${collapsed ? "main-full" : ""} ${broken && "main-layout"}`}
                >
                  <Header />
                  <div className="px-2 mb-3 div-managerequest">
                    <Container fluid>
                      {location.pathname !== "/dashboard" &&
                        location.pathname !== "/renewalPage" && <Breadcrumb />}
                      {props.children}
                    </Container>
                  </div>
                </main>
              </div>
            )
          )}
          </TourProvider>
        </UserContext.Provider>
      )}
    </>
  );
};
export default Layout;
